import {
  Center,
  Empty,
  EmptyHeadline,
  EmptyDescription,
  OutlineCircleXIcon,
} from '@frontend/legacy-components';

export const OrderListPageErrorContent = () => {
  return (
    <Center height="100%">
      <Empty>
        <OutlineCircleXIcon color="alert.error" />
        <EmptyHeadline>Couldn’t get orders</EmptyHeadline>
        <EmptyDescription>
          Try again once. If the problem persists, contact support.
        </EmptyDescription>
      </Empty>
    </Center>
  );
};
